import { Redirect, useLocalSearchParams } from 'expo-router'

import { FraternityGenderScreen } from '@/src/features/fraternity/ui/screens/FraternityGenderScreen'
import { filterSearchParams } from '@/src/general/utils/filterSearchParams'

const CommunityJoinGenderRouterPage = () => {
  const searchParams = useLocalSearchParams()
  const { idSlug } = filterSearchParams<TIdSlugParam>(searchParams)

  if (!idSlug) return <Redirect href="not-found" />

  return <FraternityGenderScreen idSlug={idSlug} searchParams={searchParams} />
}

export default CommunityJoinGenderRouterPage
